import { Directive, TemplateRef } from '@angular/core';

/**Direttiva per la modalità vista in un componente editabile */
@Directive({
  selector: '[viewMode]'
})
export class ViewModeDirective {

  /**
   * Costruttore per la direttiva ViewModeDirective
   * @param tpl {TemplateRef}
   */
  constructor(public tpl: TemplateRef<any>) { }

}
